import {
  useMemo
} from 'react';

/**
 * TODO(2026-1029迭代/机会点表单字段必填/可见/可写，文档：https://confluence.lanhanba.com/pages/viewpage.action?pageId=172107370)：
 * Locxx 拓店任务模板（taskEntry=true）通过 access=3 隐藏字段；access=null 表示模板未配置发起节点表单权限，按原逻辑显示。
 */

/**
   * @description 支持提交审批时是否可见，结合isShow最终决定是否展示
   * @param item
   * @return
   */
export const isShowWhenApprovalProcess = ({
  taskEntry,
  supportDirectApproval,
  propertyItem,
  /** 是否传统的点位评估编辑页（不包含一鸣等租户走机会点点位评估审批流的场景），是的话item的显示、禁用，参照的是机会点拓店模板、非流程设置 */
  isTraditionEvaluation,
  /** 是否机会点表单，加盟商、踩点记录时false */
  isChancepoint = true,
}) => {
  // Locxx 拓店任务模板入口（taskEntry=true）：仅 access=3 隐藏；access=1/2/null 均按原逻辑显示
  // 不与 isTraditionEvaluation 耦合：该标志在拓店任务编辑场景下由 release 逻辑置 true，会让本分支失效
  if (isChancepoint && taskEntry === true) {
    const { access } = propertyItem;
    if (access === 3) return false; // 只隐藏 access=3
    // access=1/2 显示；access=null 表示模板未配置发起节点表单权限，按原逻辑显示，不再落入审批流分支
    return true;
  }
  // 支持提交审批时（即走配置的审批流时），保持 release 原始逻辑：access=1/2 显示，access=3/null 隐藏
  if (isChancepoint && supportDirectApproval === 1 && !isTraditionEvaluation) {
    const { access } = propertyItem;
    // access 1：仅可见  2：可写 3:不可见 null:历史数据的不可见
    return access === 1 || access === 2;
  }
  return true;
};


export function useAccessIsShow({
  taskEntry,
  supportDirectApproval,
  propertyItem,
  /** 是否传统的点位评估编辑页（不包含一鸣等租户走机会点点位评估审批流的场景），是的话item的显示、禁用，参照的是机会点拓店模板、非流程设置 */
  isTraditionEvaluation,
  /** 是否机会点表单，加盟商、踩点记录时false */
  isChancepoint = true,
}
) {
  return useMemo(() => {
    // Locxx 拓店任务模板入口（taskEntry=true）：仅 access=3 隐藏；access=1/2/null 继续走后续审批流分支
    // 不与 isTraditionEvaluation 耦合：该标志在拓店任务编辑场景下由 release 逻辑置 true，会让本分支失效
    if (isChancepoint && taskEntry === true) {
      const { access } = propertyItem;
      if (access === 3) return false; // 只隐藏 access=3
      // access=1/2 显示；access=null 表示模板未配置发起节点表单权限，按原逻辑显示，不再落入审批流分支
      return true;
    }
    // 支持提交审批时（即走配置的审批流时），保持 release 原始逻辑：access=1/2 显示，access=3/null 隐藏
    if (isChancepoint && supportDirectApproval === 1 && !isTraditionEvaluation) {
      const { access } = propertyItem;
      // access 1：仅可见  2：可写 3:不可见 null:历史数据的不可见
      return access === 1 || access === 2;
    }
    return true;
  }, [propertyItem, taskEntry, supportDirectApproval, isTraditionEvaluation, isChancepoint]);
}
